import { useCheckoutData } from '@/composables/checkout/useCheckoutData';
import { useCheckoutPayment } from '@/composables/checkout/useCheckoutPayment';

export function useCheckoutPrebookSuccess() {
  const data = useCheckoutData();
  const payment = useCheckoutPayment(data);

  // Wrap handleRemoveSale to also clear payment-owned state (mercadoPagoConfig)
  // when the last sale is removed and the user is redirected away.
  const handleRemoveSale = (saleId: number | string) =>
    data.handleRemoveSale(saleId, () => {
      payment.mercadoPagoConfig.value = null;
    });

  return {
    ...data,
    ...payment,
    // Override with the wrapped version that includes payment cleanup
    handleRemoveSale,
  };
}
